import { j as r } from "../../../jsx-runtime-ClSzPYp4.js";
import e from "../Loadable.mjs";
import a from "./ThinkMoneySvgPrimaryDark.mjs";
const t = (o) => /* @__PURE__ */ r.jsx(e, {
  RenderedLogo: a,
  ...o
});
export {
  t as default
};
